
    import {Inject, Options, Vue} from 'vue-property-decorator';
    import TagsSelection from '@/profile-creation-wizard/components/for-creation/ui/3_expertise/skills/TagsSelection.vue';
    import PriceSelection from '@/profile-creation-wizard/components/for-creation/ui/3_expertise/PriceSelection.vue';
    import ExpertiseSide from '@/profile-creation-wizard/components/for-creation/ui/3_expertise/ExpertiseSide.vue';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import {CreationFormValidation, HostConfiguration} from '@/profile-creation-wizard/components/for-creation/ProfileCreationForm';
    import {ProfileCreationService} from '@/profile-creation-wizard/components/for-creation/ProfileCreationService';
    import {Getter} from 'vuex-class';
    import getters from '@/profile-creation-wizard/components/for-creation/store/getters';
    import type {ProfileCreationForm} from '@/profile-creation-wizard/components/for-creation/store';
    import StepActions from '@/profile-creation-wizard/common/ui/step/StepActions.vue';
    import StepMobileHeader from '@/profile-creation-wizard/common/ui/step/StepMobileHeader.vue';
    import {TrackingRepository} from '@/common/repositories/track/TrackingRepository';
    import {StepNavigator} from '@/profile-creation-wizard/common/step/StepNavigator';

    @Options({
        components: {
            TagsSelection,
            PriceSelection,
            ExpertiseSide,
            StepActions,
            StepMobileHeader,
        },
    })
    export default class ExpertiseStep extends Vue {
        @Inject({from: DI.creationFormValidation})
        creationFormValidation!: CreationFormValidation;
        @Inject({from: DI.profileCreationService})
        profileCreationService!: ProfileCreationService;
        @Inject({from: DI.trackingRepository})
        trackingRepository!: TrackingRepository;
        @Getter(getters.creationForm)
        creationForm!: ProfileCreationForm;
        progressPercentage = 0;

        stepName = 'expertise';

        mounted(): void {
            window.scrollTo({
                top: 0,
            });
        }

        created(): void {
            this.trackingRepository.track('expertise-view-page-v2');
            if (window.hj) {
                // Custom event Hotjar
                window.hj('event', 'profile_creation_details_page');
            }
            const meta = this.$router.currentRoute.value.meta;
            this.progressPercentage = meta.progressPercentage || 0;
            this.stepNavigator = new StepNavigator(this.$router, meta.previousStep, meta.nextStep);
        }

        get hostConfiguration(): HostConfiguration {
            return {
                priceConfig: {
                    maxPriceAllowed: this.$pageContext.mandatoryDetails.maxPriceAllowed,
                    minPriceAllowed: this.$pageContext.mandatoryDetails.minPriceAllowed,
                },
            };
        }

        get hasValidFieldPart(): boolean {
            const form = this.creationForm;

            return (
                this.creationFormValidation.isTagsValid(form.tags) &&
                this.creationFormValidation.isPriceValid(form.price, this.hostConfiguration.priceConfig)
            );
        }

        goToPrevious(): void {
            this.stepNavigator.previous();
        }

        goNext(): void {
            this.trackingRepository.track('skills-chosen-v2', {
                skills: this.creationForm.tags.map((tag) => tag.name),
            });

            this.trackingRepository.track('price-chosen-v2', {
                price: this.creationForm.price,
            });

            this.stepNavigator.next();
        }

        get priceSelectionMinValue(): number {
            if (this.$features.profileCreationRecommendedFreelancerRate250) {
                return 250;
            }
            return +this.$pageContext.mandatoryDetails.minPriceAllowed || 25;
        }

        get priceSelectionMaxValue(): number {
            return +this.$pageContext.mandatoryDetails.maxPriceAllowed || 5000;
        }
    }
